/** One background reload per this window, so a still-stale build never loops. */
export const APP_UPDATE_AUTO_RELOAD_WINDOW_MS = 5 * 60_000;
const AUTO_RELOAD_KEY = 'imai:app-update-auto-reload-at';

/** Reload a hidden tab at most once per window; returns whether it reloaded. */
export function autoReloadHiddenTabOnce(now: number = Date.now()): boolean {
  if (document.visibilityState !== 'hidden') return false;
  try {
    const last = Number(window.sessionStorage.getItem(AUTO_RELOAD_KEY)) || 0;
    if (now - last < APP_UPDATE_AUTO_RELOAD_WINDOW_MS) return false;
    window.sessionStorage.setItem(AUTO_RELOAD_KEY, String(now));
  } catch {
    // Without storage there is no loop guard, so leave the reload to the user.
    return false;
  }
  window.location.reload();
  return true;
}
